module.exports = __webpack_public_path__ + "img/biohazard.09513492.svg";